import type React from 'react';

export type BicyclingIconProps = {
  size?: string | number;
  color?: string;
  className?: string;
};

export const BicyclingIcon: React.FC<BicyclingIconProps> = ({ size = '24', color = 'currentColor', className }) => {
  return (
    <svg
      width={size}
      height={size}
      fill={color}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M14.001 14.001a4.208 4.208 0 0 1-2.985 1.237 4.209 4.209 0 0 1-2.986-1.237 4.204 4.204 0 0 1-1.237-2.985c0-1.168.472-2.221 1.237-2.986a4.195 4.195 0 0 1 2.644-1.202v4.306a.38.38 0 1 0 .762 0V6.835a4.203 4.203 0 0 1 2.565 1.195 4.209 4.209 0 0 1 1.237 2.986 4.208 4.208 0 0 1-1.237 2.985m-9.24-.763a2.003 2.003 0 0 1-2 2 2.004 2.004 0 0 1-2-2 1.996 1.996 0 0 1 1.747-1.974 12.503 12.503 0 0 0-.147 1.815c0 .096.002.15.002.154a.382.382 0 0 0 .762-.027l-.002-.127c-.001-.265.02-.927.15-1.766a1.996 1.996 0 0 1 1.488 1.925m-.027-7.207H2.903v-.508H5.28a7.482 7.482 0 0 0-.508.516c-.013-.002-.024-.008-.038-.008m6.702.043V2.175a.378.378 0 0 0-.106-.261c-.007-.008-.004-.019-.012-.027L9.541.11C9.537.106 9.53.108 9.525.104a.373.373 0 0 0-.244-.102L9.269 0H6.728a.38.38 0 1 0 0 .761h2.387l1.559 1.559v1.207c-1.824.047-3.276.511-4.404 1.234H2.522a.383.383 0 0 0-.38.381v1.27a.382.382 0 0 0 .38.381h1.66a9.754 9.754 0 0 0-1.295 2.758c-.096.323-.17.634-.234.936A2.756 2.756 0 0 0 0 13.238a2.762 2.762 0 0 0 5.523 0c0-1.3-.9-2.382-2.109-2.676.163-.74.414-1.556.806-2.346.51-1.031 1.25-2.013 2.327-2.739 1.019-.686 2.361-1.139 4.127-1.188v1.777c-2.59.179-4.642 2.314-4.643 4.95A4.986 4.986 0 0 0 11.016 16 4.986 4.986 0 0 0 16 11.016c-.001-2.609-2.012-4.725-4.564-4.942"
        fillRule="evenodd"
      />
    </svg>
  );
};
